import * as yup from 'yup';
import { stringRequired } from '../fields/index.js';

export default yup.object().shape({
  consentLetterReferenceCode: stringRequired('Consent letter reference code'),
  accessCode: stringRequired('Access code'),
});
